import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { HtmlBase, PropertyData, QueovalItem, QueovalItemModel } from '../../../../models';
import { DialogService } from '../../../../dialog/dialog.service';
import { CoreService } from '../../../../services/core.service';
import { HttpService } from '../../../../services/dataAccess.service';
import { BaseAddOnComponent } from '../base-addon.component';
import { b64UrlEncodeUnicode } from '../../../../utilities';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-searchselect',
  templateUrl: './searchselect.component.html',
  styleUrls: ['./searchselect.component.css', '../../dynamictag.component.css']
})

export class SearchSelectComponent extends BaseAddOnComponent implements OnInit {

  public list: Array<QueovalItem> = [];
  public loadDatas: boolean = false;
  private maxPopoverWidth: number = 0;
  private keyUpCounter: number = 0;

  @Input('input') input: PropertyData;
  @Output() setInput: EventEmitter<QueovalItem> = new EventEmitter<QueovalItem>(true);

  constructor(
    private httpservice: HttpService,
    private indParam: CoreService,
    private dialogservice: DialogService,
    public domSanitizer: DomSanitizer,
    protected cd: ChangeDetectorRef,
  ) { super(); }

  ngOnInit(): void {
    // GGPP
    if (!this.input) {
      const textBox: HtmlBase = new HtmlBase('myDS', 'INPUT');
      textBox.Code = 'STAGE-RESERVATION';
      this.input = new PropertyData();
      this.input.MainElementList = [];
      this.input.MainElementList.push(textBox);
    }
  }

  search(popover: any): void {
    this.keyUpCounter++;
    const currentKeyUpCounter: number = this.keyUpCounter;
    function makeDelay(ms: number): any {
      let timer: any = 0;
      return (callback: any): any => {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    }
    const values: string[] = this.input.MainElementList[0].Value.split('|');
    let value: string = '';
    if (values.length > 1)
      value = values.splice(1).join('|');
    else
      value = this.input.MainElementList[0].Value;

    const code: string = this.input.MainElementList[0].Code;

    if (value !== '' && code !== '') {
      const delay: any = makeDelay(500);
      this.loadDatas = true;
      this.cd.detectChanges();
      if (popover) {
        popover.open();
      }
      delay(() => {
        if (this.keyUpCounter == currentKeyUpCounter) {
          this.keyUpCounter = 0;         
          const sendData: string = b64UrlEncodeUnicode(`${value}|${code}`);       
          this.httpservice.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/SEARCH/${sendData}`).subscribe((result: QueovalItemModel) => {
            this.list = result.queovalItemList;
            if (this.list.length === 1 ) {
              this.input.MainElementList[0].Value = `${this.list[0].Value}|${this.list[0].Text}`;
              this.setInput.emit(this.list[0]);
            }
            this.loadDatas = false;
          }
          );
        }
      });
    }
    else {
      this.list = [];
    }
  }
  public valueChange(value: string): void {
    if (!value) {
      this.input.MainElementList[0].Value = '';
    } else {
      this.input.MainElementList[0].Value = `${this.input.MainElementList[0].Value.split('|')[0]}|${value}`;
    }
  }

  selectItem(item: QueovalItem, popover: any): void {
    this.input.MainElementList[0].Value = `${item.Value}|${item.Text}`;
    this.setInput.emit(item);
    if (popover) {
      popover.close();
    }
  }

  navig(button: HtmlBase): void {

  }

  // Calcul de la largeur de la liste
  public SetCdkViewportWidth(cdkViewportContainer: any): string {
    this.cd.detectChanges();
    if (cdkViewportContainer && cdkViewportContainer.firstChild && cdkViewportContainer.firstChild.firstChild && cdkViewportContainer.firstChild.firstChild.offsetWidth) {
      if (cdkViewportContainer.firstChild.firstChild.firstChild.offsetWidth > (this.maxPopoverWidth + 10))
        this.maxPopoverWidth = cdkViewportContainer.firstChild.firstChild.offsetWidth + 10;
      return `${this.maxPopoverWidth}px`;
    }
    return '';
  }

}





